import { render } from "./storySlider.vue?vue&type=template&id=bd0ef34a"
import script from "./storySlider.vue?vue&type=script&lang=js"
export * from "./storySlider.vue?vue&type=script&lang=js"

import "./storySlider.vue?vue&type=style&index=0&id=bd0ef34a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__